import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { apiClient } from "@/lib/api";
import WishireLogo from "@/components/wishire/WishireLogo";

/* Public admin-managed page (Privacy Policy, Terms, …) served at /p/:slug.
   Body is plain text: "## " lines render as section headings, blank lines
   separate paragraphs — no HTML is ever injected. */
export default function SitePage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    setPage(null); setErr("");
    apiClient.get(`/pages/${slug}`)
      .then(({ data }) => { setPage(data); document.title = `${data.title} · Wishire`; })
      .catch(() => setErr("This page isn't available."));
    window.scrollTo(0, 0);
  }, [slug]);

  const blocks = (page?.body || "").split(/\n{2,}/).map((b) => b.trim()).filter(Boolean);

  return (
    <div className="min-h-screen bg-[#FDFBF7] text-stone-900">
      <header className="border-b border-stone-200 bg-[#FDFBF7]/90 backdrop-blur sticky top-0">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/"><WishireLogo size="sm" wordOnly /></Link>
          <Link to="/" className="text-xs font-medium text-stone-500 hover:text-stone-900">← Back to wishire.in</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-16">
        {err ? (
          <p className="text-sm text-stone-500">{err}</p>
        ) : !page ? (
          <p className="text-sm text-stone-500 flex items-center gap-2"><Loader2 size={14} className="animate-spin" /> Loading…</p>
        ) : (
          <>
            <h1 className="font-display text-4xl md:text-5xl leading-tight">{page.title}</h1>
            {page.updated_at && (
              <p className="mt-2 text-xs font-mono uppercase tracking-widest text-stone-400">
                Last updated {new Date(page.updated_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}
              </p>
            )}
            <div className="mt-8 space-y-5">
              {blocks.length === 0 && <p className="text-sm text-stone-500">Content coming soon.</p>}
              {blocks.map((b, i) =>
                b.startsWith("## ") ? (
                  <h2 key={i} className="font-display text-2xl pt-4">{b.slice(3)}</h2>
                ) : (
                  <p key={i} className="text-[15px] leading-relaxed text-stone-700 whitespace-pre-line">{b}</p>
                )
              )}
            </div>
          </>
        )}
      </main>
      <footer className="border-t border-stone-200 py-8">
        <p className="text-center text-xs text-stone-400">© {new Date().getFullYear()} Wishire Technologies Pvt. Ltd. · New Delhi, India</p>
      </footer>
    </div>
  );
}
